import Disclaimer from '@/components/layout-auth/components/footer-auth/components/disclaimer';
import { Box, BoxProps } from '@cmpsr/components';

type FooterAuthProps = {
  disclaimerProps?: BoxProps;
} & BoxProps;

export default function FooterAuth({ disclaimerProps, ...props }: FooterAuthProps): React.ReactElement {
  return (
    <Box as="footer" position={{ base: 'initial', lg: 'relative' }} bottom="0" w="100%" {...props}>
      <Disclaimer {...disclaimerProps} />
    </Box>
  );
}
